import { COUNTERTOP } from "./0-init";
import { DINING } from "./5-dining";
import { KITCHEN_ISLAND } from "./2-island";
import { RANGE_VIEW } from "./1-range";
import { LEFT_OF_SINK } from "./4-prep";
import { LEFT_OF_RANGE } from "./3-nook";

export const SCENES = [
  COUNTERTOP, DINING, KITCHEN_ISLAND, RANGE_VIEW, LEFT_OF_RANGE, LEFT_OF_SINK
];


